import {
  appStateDefault,
  AppType,
  AppState,
  SidebarItemType,
  sidebarItems
} from "@homesusa/layout";

export const appState: AppState = {
  ...appStateDefault,
  currentApp: AppType.UserManagement,
  layout: {
    ...appStateDefault.layout,
    sidebar: {
      ...appStateDefault.layout.sidebar,
      selected: SidebarItemType.UserManagement,
      items: {
        ...sidebarItems
      }
    }
  }
};
